export class NewsService {
  static markAsFavorite(item: any, value: any, upsertAction: (payload: any) => Promise<void>) {
    const payload: any = {
      zr_news_id: item.id,
      is_favorite: value,
      user_id: '',
      UpdateFav: true,
    };

    if (item.news_read_info && item.news_read_info.length === 1) {
      payload.id = item.news_read_info[0].id;
    }

    upsertAction(payload);
  }

  static changeReadStatus(item: any, readStatus: boolean, upsertAction: (payload: any) => Promise<void>) {
    let payload: any = {
      zr_news_id: item.id,
      is_read: readStatus,
      user_id: '',
      UpdateRead: true,
    };
    if (item.news_read_info.length == 1) {
      payload.id = item.news_read_info[0].id;
    }

    upsertAction(payload);
  }

  static async downloadImageForTile(
    item: any,
    isAlreadyLoaded: boolean, // check result getAdmpNewsImages[item.id]
    getDownloadLinkAction: (payload: any) => Promise<string>,
    updateImagesAction: (payload: any) => void
  ): Promise<string> {
    if (isAlreadyLoaded) {
      return '';
    }

    item.imageIsLoaded = true;

    const image = item.news_files?.find((x: any) => x.bucket_name === 'admpnl-news-images');

    if (image) {
      const imagePayload = {
        FileName: image.filename,
        BucketName: image.bucket_name,
        DisplayName: image.display_name,
      };

      try {
        const res = await getDownloadLinkAction(imagePayload);
        const payload = {
          id: item.id,
          imageLink: res,
        };
        updateImagesAction(payload);
        return res;
      } catch (e) {
        setTimeout(() => {
          item.noImage = true;
        }, 500);
        return '';
      } finally {
        setTimeout(() => {
          item.imageIsLoaded = false;
        }, 500);
      }
    }

    setTimeout(() => {
      item.noImage = true;
    }, 500);

    return '';
  }
}
